
import {
  Component, PropSync, Prop, Mixins,
} from 'vue-property-decorator';
import focusMixin from '../mixins/focusMixin';

@Component
export default class Notification extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: false, default: '' }) title!: string | null;

  @Prop({ required: false, default: '' }) banner!: string | null;

  @Prop({ required: false, default: false }) warning!: boolean;

  @Prop({ required: false, default: '' }) redirectUrl!: string | null;

  @Prop({ required: false, default: false }) externalUrl!: boolean;

  @Prop({ required: false, default: true }) carrierMessage!: boolean;

  private redirectOrClose() {
    if (this.redirectUrl) {
      if (this.externalUrl) {
        window.location.assign(this.redirectUrl);
      } else {
        this.$router.push(this.redirectUrl);
      }

      this.$emit('redirected');
    }
    this.syncedShow = false;
  }
}
